import {boot} from 'quasar/wrappers'
import moment from 'moment'


const filters = ({
  /**
   * UNIX時間 (ミリ秒)から日時変更
   * @param {number} value unixtime ミリ秒
   * @param {string} format 変換する日時のフォーマット
   */
  onConversionDate(value, format) {
    return !value ? '' : moment(formatISO(value)).format(format)
  },
  /**
   * 日時からUNIX時間 (ミリ秒)変更
   * @param {string} value UNIX時間 (ミリ秒)に変換する日時
   * @param {string | null} target start か end か nowTime かを指定して value の値を更新する
   */
  onConversionUnix(value, target=null) {
    // yyyy/mm 形式だと iOS で moment に渡した時にエラーになるので日付部分を追加する。
    if (/^\d{4}\/(0[1-9]|1[0-2])$/.test(value)) {
      value += '/01';
    }
    const now = moment()
    return !value ? '' : target === 'start'
      ? moment(formatISO(value)).startOf('date').valueOf()
      : target === 'end'
      ? moment(formatISO(value)).endOf('date').valueOf()
      : target === 'nowTime'
      ? moment(formatISO(value)).set('second', now.second()).set('minute', now.minute()).set('hour', now.hour()).valueOf()
      :moment(formatISO(value)).valueOf()
  },
  /**
   * UNIX時間 (ミリ秒)からUNIX時間
   * @param {date} value UNIX時間 (ミリ秒)に変換する日時
   */
  onConversionStamp(value) {
    return !value ? '' : moment(formatISO(value)).unix()
  }
})

const formatISO = (date) => {
  try {
    return new Date(date).toISOString()
  } catch(e) {
    return date
  }
}

export default boot(({app, router, store}) => {
  app.config.globalProperties.$filters = filters
})

export { filters }
